import { api } from "services/api";
import { taskListSelectors } from "store/selectors";

import { allTasksFactory } from "./taskList";

class TasksAdditionalDetails {
	/** @type {Map<string, AbortController>} */
	#abortControllers = new Map();
	/** @type {Map<string, object>} */
	#additionalDetails = new Map();

	constructor () {
		this.getUserAdditionalDetails = this.getUserAdditionalDetails.bind(this);
	}

	async getUserAdditionalDetails (taskList) {
		const uniqueUserIds = [ ...new Set(taskList.flatMap(it => [ it.assigneeId, it.owner ])) ];

		const response = await Promise.all(
			uniqueUserIds.map(id => api.users.find({
				search: [ { key: "userAccountId", val: id } ],
				includeInactive: true,
			})),
		);

		const users = response.flatMap(res => res.content);
		for (const userObject of users) {
			this.#additionalDetails.set(userObject.userAccountId, userObject);
		}

		return taskListSelectors.content().items.map(it => ({
			...it,
			assigneeUserObject: this.#additionalDetails.get(it.assigneeId),
			ownerUserObject: this.#additionalDetails.get(it.owner),
		}));
	}

	asyncUpdateTasksInStore = async request => {
		if (this.#abortControllers.has(request.name)) {
			this.#abortControllers.get(request.name).abort();
		} else {
			this.#abortControllers.set(request.name, new AbortController());
		}

		const {
			items,
			totalItems,
			paging: { pageNumber, pageLimit },
		} = taskListSelectors.content();

		const tasksWithAdditionalDetails = await request(items);

		if (!this.#abortControllers.get(request.name)?.signal?.aborted) {
			allTasksFactory.setData({
				items: tasksWithAdditionalDetails,
				totalItems,
				paging: { pageLimit, pageNumber },
			});
		}

		this.#abortControllers.delete(request.name);
	}
}

export const tasksAdditionalDetails = new TasksAdditionalDetails();
